export enum ELeiStavZadosti {
    ROZP = 'ROZP', // Rozpracováná žádost
    HOTOVO = 'HOTOVO', // Vše vyřízeno
    KONTROLA = 'KONTROLA', // Probíhá kontrola u CDCP
    PLACENI = 'PLACENI', //  Čeka se na platbu
    PODPIS = 'PODPIS', // podepsáno
    CANCELED = 'CANCELED'
}
